import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const SyncoLogoIcon = (props: IconProps) => (
  <Icon w="210px" h="235px" viewBox="0 0 210 235" {...props} fill="none">
    <g clipPath="url(#clip0_205_170295)">
      <path
        d="M157.375 46.3101H64.1417C51.2703 46.3101 40.8333 56.6784 40.8333 69.4651C40.8333 82.2518 51.2703 92.6201 64.1417 92.6201H157.375C170.247 92.6201 180.683 102.988 180.683 115.775V69.4651C180.683 56.6784 170.247 46.3101 157.375 46.3101Z"
        fill="url(#paint0_linear_205_170295)"
      />
      <path
        d="M157.374 92.6202H110.758C97.8863 92.6202 87.4494 102.989 87.4494 115.775V138.93V162.085C87.4494 149.299 97.8863 138.93 110.758 138.93H157.374C170.246 138.93 180.683 128.562 180.683 115.775C180.683 102.989 170.246 92.6202 157.374 92.6202Z"
        fill="url(#paint1_linear_205_170295)"
      />
      <path
        d="M64.1417 0C51.2703 0 40.8333 10.3683 40.8333 23.155V69.465C40.8333 56.6783 51.2703 46.31 64.1417 46.31H110.758C123.63 46.31 134.067 35.9417 134.067 23.155V0H64.1417Z"
        fill="url(#paint2_linear_205_170295)"
      />
      <path
        d="M11.5134 200.173C18.1696 201.623 21.2423 204.054 21.2423 208.665C21.2423 213.827 16.9778 217.158 11.0432 217.158C6.3084 217.158 2.42494 215.577 -1.16666 212.377L0.92506 209.905C4.03832 212.717 7.02997 214.127 11.1648 214.127C15.2996 214.127 17.821 212.036 17.821 209.006C17.821 206.194 16.3292 204.614 10.054 203.293C3.17893 201.802 0.0251321 199.581 0.0251321 194.63C0.0251321 189.679 4.16804 186.438 9.84326 186.438C14.197 186.438 17.3102 187.678 20.3424 190.109L18.3804 192.71C15.6077 190.449 12.8349 189.468 9.76218 189.468C5.87871 189.468 3.40594 191.6 3.40594 194.33C3.40594 197.061 4.94635 198.771 11.5134 200.173Z"
        fill="#282644"
      />
      <path
        d="M54.3692 216.728H50.9559V204.913L38.5353 186.867H42.6296L52.699 201.802L62.8577 186.867H66.7817L54.3611 204.873V216.728H54.3692Z"
        fill="#282644"
      />
      <path
        d="M108.924 186.867H112.208V216.728H109.516L90.2284 192.24V216.728H86.9449V186.867H90.1068L108.924 210.796V186.867Z"
        fill="#282644"
      />
      <path
        d="M149.088 217.239C140.47 217.239 134.106 210.456 134.106 201.842C134.106 193.228 140.422 186.357 149.21 186.357C154.634 186.357 157.877 188.277 160.86 191.089L158.558 193.561C156.036 191.17 153.223 189.468 149.169 189.468C142.554 189.468 137.6 194.8 137.6 201.753C137.6 208.706 142.594 214.127 149.169 214.127C153.264 214.127 155.955 212.547 158.817 209.816L161.039 211.996C157.926 215.156 154.512 217.247 149.088 217.247V217.239Z"
        fill="#282644"
      />
      <path
        d="M194.718 217.239C185.629 217.239 179.524 210.116 179.524 201.842C179.524 193.569 185.71 186.357 194.807 186.357C203.903 186.357 210 193.48 210 201.753C210 210.027 203.814 217.239 194.718 217.239ZM194.718 189.468C187.891 189.468 183.027 194.93 183.027 201.753C183.027 208.576 187.98 214.127 194.807 214.127C201.633 214.127 206.498 208.665 206.498 201.842C206.498 195.019 201.544 189.468 194.718 189.468Z"
        fill="#282644"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_205_170295"
        x1="40.8333"
        y1="81.0426"
        x2="180.683"
        y2="81.0426"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F16431" />
        <stop offset="0.36" stopColor="#F68F1D" />
        <stop offset="0.79" stopColor="#FCBD08" />
        <stop offset="1" stopColor="#FFCF00" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_205_170295"
        x1="87.4494"
        y1="127.353"
        x2="180.683"
        y2="127.353"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F16431" />
        <stop offset="0.34" stopColor="#EE6130" />
        <stop offset="0.56" stopColor="#E85830" />
        <stop offset="0.75" stopColor="#DC492F" />
        <stop offset="0.91" stopColor="#CC352D" />
        <stop offset="1" stopColor="#C1272D" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_205_170295"
        x1="40.8333"
        y1="34.7325"
        x2="134.067"
        y2="34.7325"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF9500" />
        <stop offset="0.09" stopColor="#FFA900" />
        <stop offset="0.19" stopColor="#FFBA00" />
        <stop offset="0.32" stopColor="#FFC600" />
        <stop offset="0.5" stopColor="#FFCD00" />
        <stop offset="1" stopColor="#FFCF00" />
      </linearGradient>
      <clipPath id="clip0_205_170295">
        <rect width="210" height="235" rx="32" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);

export default memo(SyncoLogoIcon);
